document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname.includes('/pages/music')) {
      const bannerImages = document.querySelectorAll('#music-page .banner-image');
      const iconLinks = document.querySelectorAll('#music-page .icon-link');
  
      bannerImages.forEach(function(bannerImage) {
        bannerImage.addEventListener('mouseenter', function() {
          this.style.transform = 'rotate(360deg)';
        });
  
        bannerImage.addEventListener('mouseleave', function() {
          this.style.transform = 'rotate(0deg)';
        });
      });
  
      iconLinks.forEach(function(iconLink) {
        iconLink.addEventListener('mouseenter', function() {
          this.style.transform = 'scale(1.2)';
        });
  
        iconLink.addEventListener('mouseleave', function() {
          this.style.transform = 'scale(1)';
        });
      });
    }
  });
  